module.exports = __webpack_public_path__ + "static/code-e51832fcaf53c532b0c91a49a1843a58.jpg";